module.exports = __webpack_public_path__ + "static/media/fund_details_cover.3dbce892.png";